import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.scss']
})
export class TermsAndconditionComponent implements OnInit {
   fileUrl: string = '';
  
  constructor(private router: Router) {}
  
  ngOnInit(): void {
    this.fileUrl = sessionStorage.getItem('termsPdfUrl') || '';
    if(!this.fileUrl){
      this.router.navigate(["/auth/login"]);
    } else {
      window.location.href = this.fileUrl;
    }
  }
}
